export const selectedForm = state => state.config.opportunity.formConfig.form;
export const listFields = state => state.config.opportunity.formConfig.fields;
export const selectedField = state => state.config.opportunity.formConfig.selectedIndex;
export const isSorting = state => state.config.opportunity.formConfig.sorting;
export const usedValues = state => state.config.opportunity.formConfig.usedValues;
export const isLoading = state => state.config.opportunity.formConfig.loading;